/***
 * 询价管理-发起人搜索
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_POST_SUPPLIERQUOTEDPRICE_FINDUSERS } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class PriceUser extends React.PureComponent {
  state = {
    users: [],
    loading: false,
  };

  // 获取用户
  @Bind()
  @Debounce(1000)
  getList(value) {
    this.setState({ loading: true, users: [] });
    getData({
      api: API_POST_SUPPLIERQUOTEDPRICE_FINDUSERS,
      data: {
        userName: value,
        size: 20,
      },
    })
      .then(res => {
        const { data } = res;
        this.setState({
          users: data || [],
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  componentDidMount() {
    const { defaultKey } = this.props;
    defaultKey && this.getList(defaultKey);
  }

  handleSearch = value => {
    if (value && value.trim()) {
      this.getList(value);
    }
  };

  render() {
    const { users, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'tags'}
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        filterOption={false}
        notFoundContent={loading ? <Spin size="small" /> : null}
        onSearch={this.handleSearch}
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {users.map(item => (
          <Select.Option
            title={item.userName}
            key={item.userId}
            value={renderValue ? renderValue(item) : item.userId}>
            {item.userName}【{item.userNumber}】
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default PriceUser;
